<template>
  <div>
    <!-- key attribute forces component to reload
       https://github.com/vuejs/vue-router/issues/1490#issuecomment-306029174
    -->
    <router-view :key="$route.fullPath"/>
  </div>
</template>

<script>

// taken from lodash - https://github.com/lodash/lodash/blob/4.17.15/lodash.js
// Currently not used - use Node.textContent() instead.
// const htmlUnescapes = {
//   '&amp;': '&',
//   '&lt;': '<',
//   '&gt;': '>',
//   '&quot;': '"',
//   '&#39;': "'",
// };
// function basePropertyOf(object) {
//   return (key) => (object == null ? undefined : object[key]);
// }
// const reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g;
// const reHasEscapedHtml = RegExp(reEscapedHtml.source);
// const unescapeHtmlChar = basePropertyOf(htmlUnescapes);

// function unescape(string) {
//   return (string && reHasEscapedHtml.test(string))
//     ? string.replace(reEscapedHtml, unescapeHtmlChar)
//     : string;
// }


function htmlGetOneText(parent, name) {
  const el = parent.getElementsByClassName(name)[0];
  if (el) {
    return el.textContent;
  }
  return null;
}

function htmlGetOne(parent, name) {
  const el = parent.getElementsByClassName(name)[0];
  if (el) {
    return el.innerHTML.trim();
  }
  return null;
}

function htmlGetArray(parent, name) {
  /* get list of children elements in LI tag */
  const el = parent.getElementsByClassName(name)[0];
  const result = [];
  if (el) {
    for (const li of el.getElementsByTagName('li')) {
      result.push(li.textContent.trim());
    }
  }
  return result;
}

function htmlGetArrayUrl(parent, name) {
  /* get list of children elements in LI tag */
  const el = parent.getElementsByClassName(name)[0];
  const result = [];
  if (el) {
    for (const li of el.getElementsByTagName('li')) {
      result.push({
        name: li.textContent.trim(),
        url: li.getAttribute('url'),
      });
    }
  }
  return result;
}

export default {
  name: 'app',
  beforeMount() {
    const ssr = document.getElementById('app');
    if (!ssr) return; // hot-reload
    if (ssr.dataset.dehydrated === '1') {
      this.$store.state.needReadURLQuery = true;
    }
    const reports = [];
    for (const report of ssr.getElementsByClassName('report')) {
      const data = {};
      data.id = report.dataset.id;
      data.slug = report.dataset.slug;
      data.status = report.dataset.status;
      data.report_type = report.dataset.report_type;
      data.report_type_label = report.dataset.report_type_label;
      data.featured = report.dataset.featured;
      data.date_us_str = report.dataset.date_us_str;
      data.num_pages = report.dataset.num_pages;
      data.shareLink = report.dataset.sharelink;
      data.title = htmlGetOneText(report, 'report-title');
      data.intro = htmlGetOneText(report, 'report-intro');
      data.content = htmlGetOne(report, 'report-content');
      data.iframe = htmlGetOne(report, 'report-iframe');
      data.thumbnail = htmlGetOne(report, 'report-thumbnail');
      data.transcript = htmlGetOne(report, 'report-transcript');
      data.keywords = htmlGetArrayUrl(report, 'report-keywords');
      data.authors = htmlGetArrayUrl(report, 'report-authors');
      data.organizations = htmlGetArrayUrl(report, 'report-organizations');
      // tags
      data.region_all = Boolean(report.dataset.region_all);
      data.regions = htmlGetArray(report, 'report-region');
      data.sector_all = Boolean(report.dataset.sector_all);
      data.sectors = htmlGetArray(report, 'report-sector');
      data.technology_all = Boolean(report.dataset.technology_all);
      data.technologies = htmlGetArray(report, 'report-technology');

      data.white_paper = report.dataset.white_paper;
      data.essential_read = report.dataset.essential_read;
      data.ti_group = report.dataset.ti_group;
      data.has_doc = report.dataset.has_doc;
      data.can_download = report.dataset.can_download;
      reports.push(data);
    }
    if (ssr.dataset.list) {
      if (reports.length) {
        this.$store.commit('initReports', reports);
      }
      const pagination = document.getElementById('report-pagination');
      const pageData = {
        count: parseInt(pagination.dataset.count, 10),
        currentPage: parseInt(pagination.dataset.currentPage, 10),
        totalPages: parseInt(pagination.dataset.totalPages, 10),
      };
      this.$store.commit('setPage', pageData);
      const intro = document.getElementById('report-intro');
      this.$store.commit('setIntro', intro.innerHTML);
      const access = document.getElementById('report-accessible');
      this.$store.commit('setAccessible', access.dataset.accessible);
      const tiGroup = document.getElementById('report-tigroup');
      this.$store.commit('setTiGroup', Boolean(tiGroup.dataset.ti_group));
      const enhanced = document.getElementById('report-enhanced');
      this.$store.commit('setEnhanced', Boolean(enhanced.dataset.enhanced));
    } else { // for detail page
      this.$store.commit('setReport', reports[0]);
    }
  },
};
</script>

<style>
  .whatever { /* force CSS file to be created */
    display: block;
  }
</style>
